export default __webpack_public_path__ + "static/media/newHabitTrackerLoggedInEmptyBig.11c4e948.png";